/**
 * Typed wrapper for /salescoach/api/contacts/*. Mirrors `inbox-api.ts`: `buildApiUrl` strips
 * defaults and resolves the preset; unwrapping the envelope is the hook's job.
 */

import { apiFetch } from '@/services/api';
import { buildApiUrl } from '@/services/api-client';
import type { Filters } from '@/lib/filters-schema';
import type { ApiEnvelope, ContactsAttemptsPage, ContactsKpis, ContactsSliceKind } from './api-types';

export async function fetchContactsKpis(filters: Filters): Promise<ApiEnvelope<ContactsKpis>> {
  return apiFetch<ApiEnvelope<ContactsKpis>>(buildApiUrl('/salescoach/api/contacts/kpis', filters));
}

/** One page of the attempts behind a clicked slice (`slice` + `value`), the /traces/list pattern. */
export async function fetchContactsAttempts(
  filters: Filters,
  slice: { kind: ContactsSliceKind; value?: string },
  offset: number,
  limit: number,
): Promise<ApiEnvelope<ContactsAttemptsPage>> {
  return apiFetch<ApiEnvelope<ContactsAttemptsPage>>(
    buildApiUrl('/salescoach/api/contacts/attempts', filters, { slice: slice.kind, value: slice.value, offset, limit }),
  );
}
